































































helpers = require('../../helpers.coffee')

view_model =
  components:
    voipCard: require('./voip_report/card')
    reportList: require('./voip_report/list')
    confirm: require('../shared/modals/confirm')

  data: ->
    iniDate: ''
    endDate: ''
    voipCards: []
    voipCalls: []
    next_page: 1
    additional_time: null
    loadingCards: false
    loadingList: false
    caller_id: ''
    current_user: Session.current_user
    current_company: Session.current_company
    dynamicMask: '(##) #####-####'

  computed:
    numeric_status: ->
      @minutes_expended = if @seconds_left > 0 && @seconds_left < 60 then @max_duration - (@minutes_left+1) else @max_duration - @minutes_left
      @minutes_expended+"/"+@max_duration

    calc_bar_percentage: ->
      (@minutes_left / @max_duration) * 100

    loading: ->
      @loadingCards || @loadingList


  watch:
    caller_id: ->
      if @caller_id.length >= 15
        @dynamicMask = '(##) #####-####'
      else
        @dynamicMask = '(##) ####-####'

  methods:
    dateChanged: (value) ->
      @iniDate = value.from
      @endDate = value.to
      @loadData()

    cardTitle: (type)->
      switch type
        when 'minutes_total' then 'Minutos Totais'
        when 'fixed_bill_duration' then 'Fixo'
        when 'mobile_bill_duration' then 'Celular'
        when 'not_connected' then 'Não conectadas'
        when 'max_duration' then 'Franquia Mensal'
        when 'additional_consumed' then 'Excedentes'
        when 'fixed_added_time_consumed' then 'Adicionais Fixo'
        when 'mobile_added_time_consumed' then 'Adicionais Celular'

    cardClass: (type)->
      switch type
        when 'minutes_total' then 'total-minutes'
        when 'fixed_bill_duration' then 'fix'
        when 'mobile_bill_duration' then 'cell'
        when 'not_connected' then 'not-conected'
        when 'max_duration' then 'monthly'
        when 'additional_consumed' then 'exceeded'
        when 'fixed_added_time_consumed' then 'additional-fix'
        when 'mobile_added_time_consumed' then 'additional-cell'

    loadData: ->
      @next_page = 1
      @voipCards = []
      @voipCalls = []
      @loadCards()
      @loadVoipCalls()

    loadCards: (params) ->
      return if @loadingCards
      @loadingCards = true
      params = { q: { period: { from: @iniDate, to: @endDate }}}
      @voip_call_resources.summary @loadSuccessCard, @loadingFailure, params: params

    loadSuccessCard: (resources) ->
      @loadingCards = false
      types = ['minutes_total', 'fixed_bill_duration', 'mobile_bill_duration',
               'not_connected', 'max_duration', 'additional_consumed',
               'fixed_added_time_consumed', 'mobile_added_time_consumed']

      data = resources.data
      for type in types
        @voipCards.push
          type: type
          number: data[type]
          title: @cardTitle(type)
          cssClass: @cardClass(type)

    loadVoipCalls: ->
      return if @loadingList || !@next_page
      @loadingList = true
      params = { q: { period: { from: @iniDate, to: @endDate }}, page: @next_page }
      @voip_call_resources.index @loadSuccessVoipCalls, @loadingFailure, params: params

    loadSuccessVoipCalls: (resources)->
      @loadingList     = false
      @next_page   = resources.body.meta.next_page
      @total_count = resources.body.meta.total_count
      @voipCalls   = @voipCalls.concat(resources.body.voip_calls)

    loadingFailure: ->
      @loadingCards = false
      @loadingList = false
      @unknownError()

    openModalConfirmation: ->
      EventsBus.$emit 'confirm-modal-show', { id: "confirm-voip-caller_id" }

    save: ->
      caller_id = @caller_id
      caller_id = '+55' + caller_id.replace(/[^0-9+]+/ig, "")
      id = Session.current_company.plivo_setting?.id
      new CompaniesResource().update(@saveSuccessCallerId, @loadingFailure, { id: @current_company.id, plivo_setting_attributes: { id: id, caller_id: caller_id } })

    saveSuccessCallerId: ->
      alertify.success 'Número alterado com sucesso'

  created: ->
    @caller_id = Session.current_company.plivo_setting?.caller_id?.substring(3)
    @max_duration = Session.current_company.plivo_setting?.voip_monthly_plan?.max_duration_in_minutes()
    @minutes_left = parseInt(Session.current_company.plivo_setting?.seconds_left/60)
    @seconds_left = Session.current_company.plivo_setting?.seconds_left
    @additional_time = Session.current_company.plivo_setting?.sum_additional_minutes()

  mounted: ->
    @voip_call_resources = new VoipCallsResource Session.current_company.id
    @dateChanged(@$refs.date_range_picker.selected_option)
exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/voip.vue